import React from "react";
// import mock01 from '../assets/images/mock01.png';
// import mock02 from '../assets/images/mock02.png';
// import mock03 from '../assets/images/mock03.png';
// import mock04 from '../assets/images/mock04.png';
// import mock05 from '../assets/images/mock05.png';
// import mock06 from '../assets/images/mock06.png';
// import mock07 from '../assets/images/mock07.png';
// import mock08 from '../assets/images/mock08.png';
// import mock09 from '../assets/images/mock09.png';
// import mock10 from '../assets/images/mock10.png';
import mock1 from '../assets/images/etepian_showcase.png';
import mock2 from '../assets/images/ihw_showcase.png';
import mock3 from '../assets/images/poltanesa_showcase.png';
import mock4 from '../assets/images/hki_showcase.png';
import mock5 from '../assets/images/skj_showcase.png';
import mock6 from '../assets/images/mudah_koding_showcase.png';
import '../assets/styles/Project.scss';

function Project() {
    return (
        <div className="projects-container" id="projects">
            <h1>Projects</h1>
            <div className="projects-grid">
                <div className="project">
                    <a href="https://e-tepian.samarindakota.go.id/" target="_blank" rel="noreferrer"><img src={mock1} className="zoom" alt="thumbnail" width="100%" /></a>
                    <a href="https://e-tepian.samarindakota.go.id/" target="_blank" rel="noreferrer"><h2>e-TEPIan (FINTECH)</h2></a>
                    <p>e-TEPIan is a real-time project monitoring and permit management system developed for the Samarinda City Government, enabling transparent tracking of project progress, budget realization, and permit approvals. Developed using Laravel dan mySQL.</p>
                    <a href="https://e-tepian.samarindakota.go.id/" target="_blank" rel="noreferrer">
                        <button>View Project</button>
                    </a>
                </div>
                <div className="project">
                    {/* <a href="https://e-tepian.samarindakota.go.id/" target="_blank" rel="noreferrer"> */}
                        <img src={mock2} className="zoom" alt="thumbnail" width="100%" />
                    {/* </a> */}
                    {/* <a href="https://e-tepian.samarindakota.go.id/" target="_blank" rel="noreferrer"> */}
                        <h2>Islamic Historical Walk (Booking & Travel Web)</h2>
                    {/* </a> */}
                    <p>
                        A web-based booking and travel management system designed for Islamic historical tours.
                        Features include tour package management, online booking, scheduling, and participant data management.
                        Developed using Laravel and MySQL.
                    </p>
                    {/* <a href="https://e-tepian.samarindakota.go.id/" target="_blank" rel="noreferrer">
                        <button>View Project</button>
                    </a> */}
                </div>

                <div className="project">
                    {/* <a href="https://poltanesa.ac.id/" target="_blank" rel="noreferrer"> */}
                        <img src={mock3} className="zoom" alt="thumbnail" width="100%" />
                    {/* </a> */}
                    {/* <a href="https://poltanesa.ac.id/" target="_blank" rel="noreferrer"> */}
                        <h2>POLTANESA (Academic Correspondence Management System)</h2>
                    {/* </a> */}
                    <p>
                        An academic correspondence management system for POLTANESA to handle official letters,
                        document approvals, and archiving digitally. Improves efficiency, traceability,
                        and document security. Built with Laravel and MySQL.
                    </p>
                    {/* <a href="https://poltanesa.ac.id/" target="_blank" rel="noreferrer">
                        <button>View Project</button>
                    </a> */}
                </div>

                <div className="project">
                    {/* <a href="google.com" target="_blank" rel="noreferrer"> */}
                        <img src={mock4} className="zoom" alt="thumbnail" width="100%" />
                    {/* </a> */}
                    {/* <a href="google.com" target="_blank" rel="noreferrer"> */}
                        <h2>Copyright Registration Web</h2>
                    {/* </a> */}
                    <p>
                        A web application for managing copyright registration submissions,
                        including applicant data, document uploads, verification workflows,
                        and status tracking. Designed to simplify and digitize the registration process.
                        Developed using Laravel and MySQL.
                    </p>
                    {/* <a href="google.com" target="_blank" rel="noreferrer">
                        <button>View Project</button>
                    </a> */}
                </div>

                <div className="project">
                    {/* <a href="google.com" target="_blank" rel="noreferrer"> */}
                        <img src={mock5} className="zoom" alt="thumbnail" width="100%" />
                    {/* </a> */}
                    {/* <a href="google.com" target="_blank" rel="noreferrer"> */}
                        <h2>Web Tracking Palm Harvest (PT Sentosa Kalimantan Jaya)</h2>
                    {/* </a> */}
                    <p>
                        A plantation monitoring system for tracking palm oil harvest data,
                        including production volumes, locations, dates, and reporting.
                        Helps management monitor productivity and generate operational reports in real time.
                        Built with Laravel and MySQL.
                    </p>
                    {/* <a href="google.com" target="_blank" rel="noreferrer">
                        <button>View Project</button>
                    </a> */}
                </div>

                <div className="project">
                    {/* <a href="google.com" target="_blank" rel="noreferrer"> */}
                        <img src={mock6} className="zoom" alt="thumbnail" width="100%" />
                    {/* </a> */}
                    {/* <a href="google.com" target="_blank" rel="noreferrer"> */}
                        <h2>Mudah Koding (Learning Management System)</h2>
                    {/* </a> */}
                    <p>
                        An online learning management system focused on programming education.
                        Features include course modules, video lessons, quizzes, user progress tracking,
                        and role-based access for instructors and students.
                        Developed using Laravel and MySQL.
                    </p>
                    {/* <a href="google.com" target="_blank" rel="noreferrer">
                        <button>View Project</button>
                    </a> */}
                </div>
            </div>
        </div>
    );
}

export default Project;